import React from 'react'
import PropTypes from 'prop-types'

import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton/FlatButton'

export default class BillingFormValidationDialog extends React.Component {

  static propTypes = {
    open: PropTypes.bool.isRequired,
    message: PropTypes.string,
    onCloseRequested: PropTypes.func.isRequired
  }
  
  handleDialogClose = event => {
    event.preventDefault()
    this.props.onCloseRequested()
  }

  render() {
    if (!this.props.open) {
      return null
    }
    return (
      <Dialog
        actions={[
          <FlatButton
            key='ok'
            label='OK'
            primary={true}
            onTouchTap={this.handleDialogClose} />
        ]}
        modal={false}
        open={this.props.open}
        contentStyle={{ maxWidth: 400 }}
        title={'Validation Error'}
        onRequestClose={this.props.onCloseRequested}>
        { this.props.message }
      </Dialog>
    )
  }

}



// WEBPACK FOOTER //
// ./src/billing/common/BillingFormValidationDialog.js